import { memo, Fragment } from 'react';
import { cn } from '@divlab/divanui';

import styles from './PreviewSizes.module.css';

import type { FC } from 'react';
import type { ConfiguratorOptionItemSize } from '@Pages/PageProduct/typings';

export interface Props {
  className?: string;
  title: string;
  unit: string;
  values: ConfiguratorOptionItemSize[];
  theme?: 'light' | 'dark';
}

const PreviewSizes: FC<Props> = (props) => {
  const { title, unit, values, className, theme = 'dark', ...restProps } = props;

  return (
    <div
      {...restProps}
      className={cn(
        styles.wrap,
        { [styles.themeDark]: theme === 'dark', [styles.themeLight]: theme === 'light' },
        className,
      )}
    >
      <div className={styles.container}>
        {title && `(${title}):`}
        <div className={styles.values}>
          {values.map((val, index) => (
            <Fragment key={val.id}>
              {index !== 0 && <div className={styles.delimeter}>✕</div>}
              <div>{val.title}</div>
            </Fragment>
          ))}
        </div>
        {!!unit && ` ${unit}`}
      </div>
    </div>
  );
};

export default memo(PreviewSizes);
